export default __webpack_public_path__ + "static/media/reload.b2f48839.svg";